import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductApprovalsIndividualActionSendRequestEntityParams {
  limited_ordering_request_id: number;
  product_id: number;
  product_line_id: number;
  action: string;
}
export class ProductApprovalsIndividualActionSendRequestEntity extends BaseEntityClass {
  limited_ordering_request_id: number;
  product_id: number;
  product_line_id: number;
  action: string;
  constructor(params: ProductApprovalsIndividualActionSendRequestEntityParams) {
    super();
    this.type = "product_approvals_individual_action_send_request";
    this.entity_version = 1;
    this.limited_ordering_request_id = params.limited_ordering_request_id;
    this.product_id = params.product_id;
    this.product_line_id = params.product_line_id;
    this.action = params.action;
  }
}
